export type Gender = 'm' | 'f';

export type Language = 'en' | 'ru';

export interface SelectOption {
  value: string;
  label: string;
}

export enum PriceType {
  TON = 'ton',
  COOKIE = 'cookie',
}

export type DotsColorType = 'accent' | 'white';

export type DotsOrientation = 'horizontal' | 'vertical';

export type TelegramImpactType = 'medium' | 'light' | 'heavy' | 'rigid' | 'soft';

export type TelegramNotificationType = 'error' | 'success' | 'warning';

export enum HttpStatusCode {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  CONFLICT = 409,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
}

export interface RequestError {
  status: HttpStatusCode;
  data?: {
    ok: false;
    message: string;
  };
}

export enum LoginMethod {
  TELEGRAM = 'telegram',
  EMAIL = 'email',
}

export enum BalanceActionType {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}

export type StreakDay = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface FortuneWheelSegmentsType {
  value: string;
  chance: number;
  type: 'building' | 'upgrade' | 'cookie' | 'ton' | 'prediction' | 'card';
}
